import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=c8fa430e&scoped=true"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"
import style0 from "./MainLayout.vue?vue&type=style&index=0&id=c8fa430e&prod&lang=css"
import style1 from "./MainLayout.vue?vue&type=style&index=1&id=c8fa430e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fa430e",
  null
  
)

export default component.exports